export const PREVIEW_HEADER_DOM_ID = 'article-preview-header';
